import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Adds a mobile-friendly viewport *once* per page.
 * Keep it separate so every page can import it with one line.
 */
const ViewportHelmet = () => (
  <Helmet>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, viewport-fit=cover"
    />
  </Helmet>
);

export default ViewportHelmet;